/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "meet Ugochukwu",
  title: "Hi all, I'm Ugochukwu",
  subTitle: emoji(
    "A passionate Full Stack Software Engineer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / React Native and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1AkRa4IrhM_lwtGrISOFeH9KBpbN4N7n1/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/rockspetre",
  linkedin: "https://www.linkedin.com/in/ugochukwu-nwajagu-018740103/",
  gmail: "rockspetre@gmail.com",
  // gitlab: "https://gitlab.com/rockspetre",
  // facebook: "https://www.facebook.com/saad.pasta7",
  // medium: "https://medium.com/@saadpasta",
  // stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji("⚡ Backend development and Software Architecture design"),
    emoji("⚡ Cross platform mobile application development"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: false, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Harvard University",
      logo: require("./assets/images/harvardLogo.png"),
      subHeader: "Master of Science in Computer Science",
      duration: "September 2017 - April 2019",
      desc: "Participated in the research of XXX and published 3 papers.",
      descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]
    },
    {
      schoolName: "Stanford University",
      logo: require("./assets/images/stanfordLogo.png"),
      subHeader: "Bachelor of Science in Computer Science",
      duration: "September 2013 - April 2017",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Web Security, Operating Systems, ...",
      descBullets: ["Lorem ipsum dolor sit amet, consectetur adipiscing elit"]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "80%"
    },
    {
      Stack: "Mobile application development",
      progressPercentage: "75%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Software Development Engineer",
      company: "Fintechx.eu",
      companylogo: require("./assets/images/fintechxlogo.jpeg"),
      date: "October 2022 – Present",
      desc: "Senior development engineer in a team building the next financial solution that will revolutionise finance. \n Still in stealth mode.",
      descBullets: []
    },
    {
      role: "Product Engineering Manager",
      company: "Infiuss Health",
      companylogo: require("./assets/images/infiusslogo.jpeg"),
      date: "April 2022 – September 2022",
      desc: "Product engineering manager in a company digitising the clinical trials processes in Africa.",
      descBullets: [
        "Managing the engineering and product team.",
        "Interpret business requirements and translate them to technical terms and vice versa.",
        "Design high level architectural designs.",
        "Implementation of highly scalable backend APIs and systems.",
        "Design and implement complex algorithms and approaches to engineering and product problems.",
      ]
    },
    {
      role: "Senior Software Engineer",
      company: "Medable",
      companylogo: require("./assets/images/medable.png"),
      date: "November 2020 – April 2022",
      desc: "Full-stack software engineer in a company transforming healthcare by enabling patient generated data to drive clinical research, healthcare delivery, and personalised and predictive medicine.",
      descBullets: [
        "Worked as a member of the core backend team in implementing new features and upgrading already existing features to a Backend as a service that powers all Medable client facing applications.",
        "In charge of building and maintaining several internally used tools",
        "Mentoring and acting as a point of knowledge source for newly onboarded software engineers"
      ]
    },
    {
      role: "Senior Backend Engineer",
      company: "Allawee",
      companylogo: require("./assets/images/allawee.webp"),
      date: "October 2021 – January 2022",
      desc: `Senior Backend Engineer building a SaaS unlocking Credit Access for every African.`,
      descBullets: [
        "Author, maintain, and document internal and external-facing APIs .",
        "Support the full development cycle of the engineering team, from capturing requirements to system design to execution.",
        "Constantly improve the stability, scalability, and security of backend services.",
        "Provide sample code and testing environments to facilitate a smooth and error-free development process.",
        "Analyze current programs including performance, diagnosis and troubleshooting, and design solutions to problematic programming.",
        "Conduct design reviews to ensure code developed meets the best standard methodologies guidelines, unit testing, security, and scalability and maintainability guidelines.",
        "Review code and provide feedback relative to best practices and improving performance.",
        "Provide assistance to testers and support personnel as needed to resolve the system problems."
      ]
    },
    {
      role: "Software Engineer",
      company: "Andela",
      companylogo: require("./assets/images/andelalogo.png"),
      date: "March 2020 – April 2022",
      desc: `Andela provides companies with access to the top 1% of global tech talent. We identify high-potential
      developers on the African continent, shape them into world-class technical leaders, and pair them with
      companies as full-time, distributed team members. This allows Andela's partners, which range from
      startups to Fortune 500s, to accelerate their product roadmaps while minimizing time spent interviewing,
      on-boarding, and training new hires.
      Andela is backed by investors including Spark Capital, Omidyar Network, Susa Ventures, Steve Case,
      Founder Collective, Rothenberg Ventures, Learn Capital and more.
      Learn more about us at www.andela.com..`
    },
    {
      role: "Software Engineer - Frontend Lead",
      company: "Membio",
      companylogo: require("./assets/images/membio.jpeg"),
      date: "March 2020 – October 2020",
      desc: `Frontend lead in a team of software engineers tasked with the development of a futuristic real estate
      management system and a marketing automation tool to serve millions of customers in the United
      States.`,
      descBullets: [
        "Development of a custom component library tailored to best serve other frontend engineers across several teams.",
        "Perform code reviews for other team members.",
        "Interface with backend developers as to what approach will be best for optimum performance.",
        "Design and development of mockup screens to match specifications."
      ]
    },
    {
      role: "Software Engineer - Team lead",
      company: "KPMG",
      companylogo: require("./assets/images/kpmg.svg"),
      date: "January 2019 – February 2020",
      desc: `Led a team of software engineers in the development of multiple enterprise level solutions across the
      web, mobile and AI eco-systems currently being
      used internally and by KPMG clients all around the globe.`
    },
    {
      role: "Software developer",
      company: "Qualinext Nig Ltd",
      // companylogo: require("./assets/images/kpmg.svg"),
      date: "June 2015 – December 2018",
      desc: ``,
      descBullets: [
        "Develop software (mobile and desktop) to solve basic/complex problems.",
        "Design and develop websites / web applications for clients.",
        "Recommend and help customers make technical decisions based on their needs.",
        "Teach software development principles."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects worth mentioning",
  subtitle: "This is not an exhaustive list of projects I have worked on. Just mentioning a few",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/clarity-landing.png"),
      projectName: "Clarity",
      projectDesc: "A web and mobile platform that supports Patient-First Data Sharing Model. Allowing you to deliver data securely to patients, payers, providers, labs, researchers, and others, all through one easy-to-use data hub.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.onyxhealth.io/clarity/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/kpmg-ethics.webp"),
      projectName: "KPMG Ethics Platform",
      projectDesc: "The KPMG Nigeria WhistleBlowing Application is a mobile application developed by KPMG to enable employees, vendors and other stakeholders (such as an organisation’s shareholders, customers, service providers and business partners) of KPMG clients, to anonymously report any activity that is deemed illegal or unacceptable.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://play.google.com/store/apps/details?id=ng.kpmg.nigeriaethics"
        }
      ]
    },
    {
      image: require("./assets/images/allawee.webp"),
      projectName: "Allawee",
      projectDesc: "A Software as a Service (SaaS) providing features that enable unlocking Credit Access for every African",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://allawee.com/"
        }
      ]
    },
    {
      image: require("./assets/images/mindmirror.svg"),
      projectName: "Mind Mirror",
      projectDesc: "An idea prototyping and pitching platform.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://mindmirror.co"
        }
      ]
    },
    {
      image: require("./assets/images/kpmg.png"),
      projectName: "KPMG Sentilytics",
      projectDesc: "An AI powered platform that gives detailed insights on how a brand is performing by analysing tags related to the brand from various internet sources like Twitter and Facebook and running through Machine learning models to give detailed insights on what users think about the brand.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://home.kpmg/ng/en/home.html"
        }
      ]
    },
    {
      image: require("./assets/images/kpmg.png"),
      projectName: "KPMG HR Automation Platform",
      projectDesc: "A web platform that automates every process involved in the management of human resources in a modern workplace. From recruitement to performance reviews and promotions etc etc",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://home.kpmg/ng/en/home.html"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Continuous Delivery and DevOps",
      subtitle:
        "University of Virginia Darden School of Business - Cousera",
      image: require("./assets/images/devops.jpeg"),
      footerLink: [
        {
          name: "Certification link",
          url: "https://coursera.org/share/32a6cd16e248f2ccf40f5835c659faa0"
        },
        /* {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        } */
      ]
    },
    {
      title: "Version Control with Git",
      subtitle:
        "The Version Control with Git course provides  you with a solid, hands-on foundation for understanding the Git version control system.",
      image: require("./assets/images/git.jpeg"),
      footerLink: [
        {
          name: "Certification link",
          url: "https://coursera.org/share/b9be140d1d8a470d698778c3dc3cd6c5"
        }
      ]
    },

    {
      title: "React.Js Certification",
      subtitle: "Certification proving mastery of React.Js and its principles.",
      image: require("./assets/images/hackerank.jpeg"),
      footerLink: [
        {name: "Certification link", url: "https://www.hackerrank.com/certificates/0424a40ba492"}
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",

  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+2348162056579",
  email_address: "rockspetre@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails
};
